import { ReactElement } from 'react';
import { UIButton } from '@/ui';
import { useAcknowledgeTaskAction } from '../actions';
import { useTasksTranslation } from '../hooks';

const HEIGHT = 32;

type AcknowledgeAlertButtonProps = {
    taskId: string;
};

export function AcknowledgeAlertButton({
    taskId
}: AcknowledgeAlertButtonProps): ReactElement {
    const { t } = useTasksTranslation();
    const { acknowledge, loading } = useAcknowledgeTaskAction({ taskId });

    return (
        <UIButton
            variant="primary"
            onClick={() => {
                acknowledge().catch(() => {}); // Error handled in the action
            }}
            loading={loading}
            customHeight={HEIGHT}
            leftIcon="arrow-down-circle"
        >
            {t('components.acknowledge_alert_button.label')}
        </UIButton>
    );
}
